import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const UnassortedDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="Unassorted Section"
      sectionId="unassorted"
      sectionKey="Unassorted"
      description="Handling Unassorted/Unsorted Goods"
      backRoute="/"
    />
  );
};

export default UnassortedDashboard;
